import PlotlyChart from './PlotlyChart'
import { resolveColumnRef, resolveValue, formatValue } from '../utils/chartDataUtils'
import { COLORS, mergeLayout, mergeConfig } from '../utils/chartTheme'

export default function PieChartV2({ data, chartOptions = {}, dimensionInfo = {} }) {
  const {
    columns = [],
    labels: labelsRef,
    values: valuesRef,
    donut = false,
    title,
    layout: customLayout = {},
    config: customConfig = {}
  } = chartOptions

  if (!data || data.length === 0) {
    return <p>No data available.</p>
  }

  const labelsColumn = resolveColumnRef(labelsRef, columns)
  const valuesColumn = resolveColumnRef(valuesRef, columns)

  const labels = data.map(row => {
    const val = resolveValue(row, labelsColumn, dimensionInfo)
    return formatValue(val, labelsColumn) || String(val)
  })
  const values = data.map(row => resolveValue(row, valuesColumn, dimensionInfo))

  const trace = {
    labels,
    values,
    type: 'pie',
    hole: donut ? 0.45 : 0,
    marker: { colors: COLORS },
    textinfo: 'none',
    hoverinfo: 'label+value+percent',
    sort: false,
  }

  const layout = mergeLayout({
    ...(title ? { title: { text: title, font: { size: 15, color: '#334155' }, x: 0, xanchor: 'left', pad: { l: 4 } } } : {}),
    margin: { t: title ? 48 : 24, r: 16, b: 24, l: 16 },
    showlegend: true,
    legend: { orientation: 'h', y: -0.1 },
    ...customLayout,
  })

  const config = mergeConfig(customConfig)

  return (
    <PlotlyChart
      data={[trace]}
      useResizeHandler={true}
      layout={layout}
      config={config}
      style={{ width: '100%', height: '100%' }}
    />
  )
}
